import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getAltFromSrc from 'commons/getAltFromSrc';
import getImageUrlWithoutQuery from 'commons/getImageUrlWithoutQuery';
import useBrokenImageUrls from 'global-state/brokenImageUrls/useBrokenImageUrls';
import useSetBrokenImageUrl from 'global-state/brokenImageUrls/useSetBrokenImageUrl';
import JBImage from 'components/essentials/JBImage';
import Placeholder from 'components/consumer/Placeholder';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import PDPVideoPosterFrame from '../../PDPVideoPosterFrame';
import { getThumbnailImageImgixPropsForPhoto } from '../helpers/imgix-props';
import { PDP_GALLERY_THUMBNAIL_IMAGE } from '../specs/testIds';
const PDPDesktopHeroThumbnail = t0 => {
  const $ = _c(49);
  const {
    ariaLabel,
    ariaPressed,
    children,
    fallbackSrc,
    icon,
    iconCenter: t1,
    loading: t2,
    isSelected: t3,
    onClick: t4,
    onLoadFailure: t5,
    onMouseEnter: t6,
    src,
    title,
    type: t7,
    isConfigFlipped: t8,
    isCylindoPhoto: t9,
    iconClass: t10,
    videoPosterUrl
  } = t0;
  const iconCenter = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const isSelected = t3 === undefined ? false : t3;
  const onClick = t4 === undefined ? _temp : t4;
  const onLoadFailure = t5 === undefined ? _temp2 : t5;
  const onMouseEnter = t6 === undefined ? _temp3 : t6;
  const type = t7 === undefined ? "studio" : t7;
  const isConfigFlipped = t8 === undefined ? false : t8;
  const isCylindoPhoto = t9 === undefined ? false : t9;
  const iconClass = t10 === undefined ? "" : t10;
  const [isError, setIsError] = useState(false);
  const brokenImageUrls = useBrokenImageUrls();
  const setBrokenImageUrl = useSetBrokenImageUrl();
  let t11;
  if ($[0] !== brokenImageUrls || $[1] !== isCylindoPhoto || $[2] !== src) {
    t11 = isCylindoPhoto && brokenImageUrls.includes(getImageUrlWithoutQuery(src));
    $[0] = brokenImageUrls;
    $[1] = isCylindoPhoto;
    $[2] = src;
    $[3] = t11;
  } else {
    t11 = $[3];
  }
  const isCylindoSrcBroken = t11;
  const isCylindoFallbackBroken = !fallbackSrc || brokenImageUrls.includes(getImageUrlWithoutQuery(fallbackSrc));
  const cylindoSrc = isCylindoSrcBroken && fallbackSrc ? fallbackSrc : src;
  if (!(loading || src || children || icon || videoPosterUrl) || isError || isCylindoSrcBroken && isCylindoFallbackBroken) {
    return null;
  }
  const t12 = !isSelected;
  let t13;
  if ($[4] !== isSelected || $[5] !== loading || $[6] !== t12) {
    t13 = classNames("items-stretch border border-solid rounded bg-white flex justify-between h-[38px] overflow-hidden w-11 lg:max-[1100px]:h-[33px] lg:max-[1100px]:w-[39px] [&+&]:ml-1", "hover:cursor-pointer hover:border-brand-dark", "focus-visible:outline-brand", {
      "hover:cursor-default hover:border-gray-light8": loading,
      "border-gray-light7": t12,
      "border-brand-dark": isSelected
    });
    $[4] = isSelected;
    $[5] = loading;
    $[6] = t12;
    $[7] = t13;
  } else {
    t13 = $[7];
  }
  const t14 = (type === "configuration" || type === "cylindo") && isConfigFlipped;
  let t15;
  if ($[8] !== t14) {
    t15 = classNames("relative items-center flex justify-center h-full w-full", {
      "scale-x-[-1]": t14
    });
    $[8] = t14;
    $[9] = t15;
  } else {
    t15 = $[9];
  }
  let t16;
  if ($[10] !== cylindoSrc || $[11] !== fallbackSrc || $[12] !== isCylindoPhoto || $[13] !== isCylindoSrcBroken || $[14] !== onLoadFailure || $[15] !== setBrokenImageUrl || $[16] !== src || $[17] !== type) {
    t16 = !!src && (isCylindoPhoto ? <img className="h-full" data-testid={PDP_GALLERY_THUMBNAIL_IMAGE} src={cylindoSrc} width={44} height={38} alt={getAltFromSrc(cylindoSrc)} onError={() => {
      if (!isCylindoSrcBroken) {
        setBrokenImageUrl(src);
        onLoadFailure();
      } else {
        setBrokenImageUrl(fallbackSrc);
      }
    }} /> : <JBImage className={classNames("flex-1", {
      "object-none h-[38px] w-11": type === "configuration" || type === "cylindo",
      "h-full object-cover w-full": type === "studio"
    })} data-testid={PDP_GALLERY_THUMBNAIL_IMAGE} forPage="pdp" lazy={false} onLoad={isFail => {
      if (!isFail) {
        return;
      }
      setIsError(true);
      onLoadFailure();
    }} {...getThumbnailImageImgixPropsForPhoto({
      src,
      type
    })} />);
    $[10] = cylindoSrc;
    $[11] = fallbackSrc;
    $[12] = isCylindoPhoto;
    $[13] = isCylindoSrcBroken;
    $[14] = onLoadFailure;
    $[15] = setBrokenImageUrl;
    $[16] = src;
    $[17] = type;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== src || $[20] !== videoPosterUrl) {
    t17 = !src && <PDPVideoPosterFrame className="h-full object-cover w-full" src={videoPosterUrl} />;
    $[19] = src;
    $[20] = videoPosterUrl;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== children) {
    t18 = !!children && <div className="text-xs font-bold text-gray">{children}</div>;
    $[22] = children;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== icon || $[25] !== iconCenter || $[26] !== iconClass) {
    t19 = !!icon && <div className={classNames(`items-center flex justify-center [&_svg]:p-[5px] ${iconClass}`, {
      absolute: iconCenter
    })}>{icon}</div>;
    $[24] = icon;
    $[25] = iconCenter;
    $[26] = iconClass;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t15 || $[29] !== t16 || $[30] !== t17 || $[31] !== t18 || $[32] !== t19) {
    t20 = <div className={t15}>{t16}{t17}{t18}{t19}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== loading || $[35] !== t20) {
    t21 = <Placeholder loading={loading} type="rect" className="!mr-0">{t20}</Placeholder>;
    $[34] = loading;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== ariaPressed || $[38] !== isSelected) {
    t22 = !!isSelected && ariaPressed === undefined && <VisuallyHidden>- selected</VisuallyHidden>;
    $[37] = ariaPressed;
    $[38] = isSelected;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== ariaLabel || $[41] !== ariaPressed || $[42] !== onClick || $[43] !== onMouseEnter || $[44] !== t13 || $[45] !== t21 || $[46] !== t22 || $[47] !== title) {
    t23 = <button aria-label={ariaLabel} aria-pressed={ariaPressed} title={title} className={t13} onClick={onClick} onMouseEnter={onMouseEnter} type="button">{t21}{t22}</button>;
    $[40] = ariaLabel;
    $[41] = ariaPressed;
    $[42] = onClick;
    $[43] = onMouseEnter;
    $[44] = t13;
    $[45] = t21;
    $[46] = t22;
    $[47] = title;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  return t23;
};
PDPDesktopHeroThumbnail.propTypes = {
  ariaLabel: PropTypes.string,
  ariaPressed: PropTypes.bool,
  children: PropTypes.node,
  fallbackSrc: PropTypes.string,
  icon: PropTypes.node,
  iconCenter: PropTypes.bool,
  iconClass: PropTypes.string,
  isConfigFlipped: PropTypes.bool,
  isCylindoPhoto: PropTypes.bool,
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onLoadFailure: PropTypes.func,
  onMouseEnter: PropTypes.func,
  src: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['buildyourown', 'configuration', 'cylindo', 'dimensional', 'open-close', 'studio']),
  videoPosterUrl: PropTypes.string
};
export default PDPDesktopHeroThumbnail;
function _temp() {}
function _temp2() {}
function _temp3() {}